import { Route, Redirect } from "react-router-dom";
import { useState } from "react";
import Header from "../Common/Header/";
import { RoutesUrl } from "../Routes/constents";
import { getTolocalStorage, LoginKeys } from "../Constants/commenFeatures";

function VendorPrivateRoute({ component: Component, ...rest }) {
  const [auth, setAuth] = useState(
    getTolocalStorage(LoginKeys.AccessToken) ? true : false
  );

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!auth) {
          // not logged in so redirect to login page with the return url
          return (
            <Redirect
              to={{
                pathname: RoutesUrl.VendorLogin,
                state: { from: props.location },
              }}
            />
          );
        } else {
          return <Header>{<Component {...props} />}</Header>;
        }
      }}
    />
  );
}

export default VendorPrivateRoute;
